import axios from 'axios';

// Same-origin: Vite (dev) and nginx (Docker) proxy /v1 to the API.
export const apiClient = axios.create();

// Add request interceptor
apiClient.interceptors.request.use(
  config => config,
  error => Promise.reject(error),
);

// Add a response interceptor
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Navigate to login page using window.location.href
      window.location.href = '/login';
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(error);
  },
);
